import { Config } from "../../../api/config";
export var FFRKeys = {
    Paging: 'ffrPaging',
    Create: 'ffrCreate',
    Update: 'ffrUpdate',
    PartsList: 'ffrPartsList'
};
export var appointmentPagingURL = "".concat(Config.baseURL, "Appointment/Paging");
